import { css } from 'styled-components';
import {COLORS, TYPOGRAPHY} from '../../design/tokens';

const WIDTHS = {
  small: '124px',
  normal: '208px'
};

const sizes = ({ width, fluid }) => css`
  width: ${() => (fluid ? '100%' : WIDTHS[width])} !important;
  height: 40px !important;
`;

const align = ({ labelPosition }) => css`
  text-align: ${!labelPosition
    ? 'auto'
    : labelPosition === 'left'
    ? 'right'
    : 'left'} !important;
`;

const onActive = (color, props) => css`
      color: ${COLORS.BUTTON[color].TEXT} !important;
      background-color: ${COLORS.BUTTON[color].BACKGROUND} !important;
      ${color === 'WHITE'
        ? css`
            border: 1px solid ${COLORS.BUTTON.WHITE.BORDER} !important;
          `
        : ''}
    `;

const buttonBase = props => {
  let states = null;

  if (!props.disabled) {
    states = css`
      &:hover {
        opacity: 0.8;
      }
      &:active {
        opacity: 0.7;
      }
    `
  }

  return css`
    ${sizes}
    ${align}
    line-height: 4px !important;
    border-radius: 50px !important;
    font-family: ${TYPOGRAPHY.BASE.FONT_FAMILY} !important;
    font-size: 14px !important;
    letter-spacing: 0.6px;

    && {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      &.icon {
        justify-content: space-between;
      }
    }

    &.left {
      svg {
        transform: rotate(180deg);
        position: absolute;
        left: 20px;
        top: 15px;
      }
    }

    &.right {
      svg {
        position: absolute;
        right: 20px;
        top: 15px;
      }
    }

    ${states}
    &.button,
    &.icon.button{
      font-family: ${TYPOGRAPHY.BASE.FONT_FAMILY};
    }
  `;
};

const styles = {
  white: css`
    ${props => onActive('WHITE', props)}
    ${props => buttonBase(props)}

    &:hover {
      opacity: 0.5;
    }

    &:active {
      opacity: 0.3;
    }
  `,
  seablue: css`
    ${props => onActive('SEA_BLUE', props)}
    ${props => buttonBase(props)}
  `,
  success: css`
    ${props => onActive('SUCCESS', props)};
    ${props => buttonBase(props)}
      &.button.disabled {
        opacity: 1 !important;
      }
    }
  `,
  info: css`
    ${props => onActive('INFO', props)};
    ${props => buttonBase(props)}
      &.button.disabled {
        opacity: 1 !important;
        font-weight: 400;
      }
    }
  `,
  warning: css`
    ${props => onActive('WARNING', props)}
    ${props => buttonBase(props)}
  `,
  danger: css`
    ${props => onActive('DANGER', props)}
    ${props => buttonBase(props)}
  `,
  iconWhite: css`
      fill: ${COLORS.BUTTON.WHITE.TEXT};
      background-color: transparent;
  `,
  iconSeablue: css`
      fill: ${COLORS.BUTTON.SEA_BLUE.TEXT};
      background-color: transparent;

  `
};

export default styles;
